//  引入一些工具方法
exports.install = function (Vue, options) {
  Vue.prototype.setToken = function (text) { // 全局函数1
    localStorage.setItem('Authorization', text)
  }
  Vue.prototype.getToken = function () { // 全局函数1
    return localStorage.getItem('Authorization')
  }
  Vue.prototype.myDateFormat = function (text) { // 全局函数1
    return Date(parseInt(text)).toLocaleDateString().replace(/\//g, "-") + " " + new Date(parseInt(text)).toTimeString().substr(0, 8)
  }
  Vue.prototype.timestampToTime = function (timestamp) { // 全局函数2
    if (timestamp != '' && timestamp != null) {
      var date = new Date(timestamp)
      var Y = date.getFullYear() + '-'
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
      var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
      var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
      var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
      return Y + M + D + h + m + s
      // return Y+M+D
    }
  }
  Vue.prototype.convertDateFromString = function (dateString) { // 全局函数2
    if (dateString) {
      var arr1 = dateString.split('')
      var sdate = arr1[0].split('-')
      var date = new Date(sdate[0], sdate[1] - 1, sdate[2])
      return date;
    }
  }
}
//



// WEBPACK FOOTER //
// ./src/components/_util/base.js